import moment from "moment";
import { useEffect, useState } from "react";

import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter'
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter'
// import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox'

import { Chip, IconButton, Box, Tooltip, Typography } from "@mui/material";

import { Link } from 'react-router-dom';

import { useTranslations } from "./useTranslations";

// import { CommonIcons, icons } from "../components/common/CommonIcons";

export const dataGridFilterTypes = {
    select: SelectFilter,
    date: DateFilter
}

export const dataGridFilterTypesProps = {
    date: {
        default: {
            dateFormat: 'YYYY-MM-DD',
            cancelButton: true,
            highlightWeekends: false,
            placeholder: `YYYY-MM-DD`
        }
    }
}

export function useDataGridParams(name) {

    const [id, setId] = useState(name);
    const [schema, setSchema] = useState([]);
    const [skipDefaultSchema, setSkipDefaultSchema] = useState(false);
    const [rowMenuRender, setRowMenuRender] = useState([]);
    const [columns, setColumns] = useState();
    const [filterValues, setFilterValues] = useState();

    const defineColumns = (data) => setSchema(data)
    const hideDefaultColumns = (val) => setSkipDefaultSchema(val)
    const defineRowMenuRender = (data) => setRowMenuRender(data)

    const { t } = useTranslations({ ns: ["common"] })

    // const filterTypes = Object.assign({}, ReactDataGrid.defaultProps.filterTypes, {
    //     country: {
    //         name: 'country',
    //         operators: [
    //             {
    //                 name: 'europe',
    //                 fn: ({ value, filterValue, data }) => {
    //                     if (filterValue == null) {
    //                         return true
    //                     }
    //                     const isInEurope = value !== 'usa' && value !== 'ca'

    //                     return filterValue ?
    //                         isInEurope :
    //                         !isInEurope
    //                 }
    //             }
    //         ]
    //     }
    // });

    const getFilterComponent = (id) => {
        if (id === dataGridFilterTypes.select) return SelectFilter
        if (id === dataGridFilterTypes.date) return DateFilter
        return NumberFilter
    }

    const getColumn = (props) => {

        const {
            name,
            header,
            sortable,
            textAlign,
            defaultFlex = 1,
            renderValue,
            defaultWidth = 0,
            filter
        } = props;

        let filterObject = {}

        if (filter?.type) {
            filterObject = {
                filterEditor: getFilterComponent(filter?.type),
                filterEditorProps: filter?.props
            }
        }

        return {
            name,
            header,
            sortable,
            textAlign,
            defaultFlex,
            defaultWidth,
            showColumnMenuTool: false,
            render: renderValue ? ({ value, cellProps }) => renderValue({ value, cellProps }) : null,
            // filterEditor: BoolFilter,
            // filterEditor: SelectFilter,
            ...filterObject
        }
    }

    const getFilterValue = (props) => {

        const {
            name,
            operator = 'contains',
            type = 'string',
            value = ''
        } = props;

        return {
            name,
            operator,
            type,
            value
        }
    }

    useEffect(() => {

        updateColumns();
        updateFilterValue();

    }, [schema])


    const updateFilterValue = () => {

        let returnFilterValue = [];

        for (let i = 0; i < schema.length; i += 1) {

            const item = schema[i];

            returnFilterValue.push(
                getFilterValue(item)
            )

        }

        if (skipDefaultSchema === false) {
            // insert the datetime
            returnFilterValue.push(
                getFilterValue({
                    name: 'ax_createdatetime',
                    operator: 'eq',
                    type: 'string',
                    value: ''
                })
            )
        }


        // returnFilterValue.push(
        //     getFilterValue({
        //         name: 'ax_createusername', 
        //         operator: 'eq',
        //         type: 'string',
        //         value: ''
        //     })
        // )

        setFilterValues(returnFilterValue)

    }

    const updateColumns = () => {

        let returnColumns = [];

        for (let i = 0; i < schema.length; i += 1) {

            const item = schema[i];

            returnColumns.push(
                getColumn(item)
            )

        }

        if (skipDefaultSchema === false) {
            // insert the datetime
            returnColumns.push(
                getColumn({
                    name: 'ax_createdatetime',
                    // header: 'Created At',
                    header: `${t("createdAt")}`,
                    renderValue: ({ value }) => getRenderColumnDateTimeDisplay(value),
                    filter: {
                        type: dataGridFilterTypes.date,
                        props: (props, { index }) => {
                            return {
                                ...dataGridFilterTypesProps.date.default
                            }
                        }
                    }
                })
            )

            returnColumns.push(
                getColumn({
                    name: 'ax_createusername',
                    // header: 'Created By',
                    header: `${t("createdBy")}`,
                    renderValue: ({ value }) => getRenderColumnTextDisplay(value),
                    filter: {
                        type: dataGridFilterTypes.date,
                        props: (props, { index }) => {
                            return {
                                ...dataGridFilterTypesProps.date.default
                            }
                        }
                    }
                })
            )
        }

        // returnColumns.push(
        //     getColumn({
        //         name: '',
        //         header: 'Created By',
        //         renderValue: ({ value }) => getRenderColumnTextDisplay(value),
        //     })
        // )

        // insert the action row menu
        if (rowMenuRender?.renderValue) {
            returnColumns.push(
                getColumn({
                    name: 'action',
                    header: '',
                    sortable: false,
                    defaultFlex: 0,
                    defaultWidth: 80,
                    renderValue: rowMenuRender.renderValue
                })
            )
        }

        setColumns(returnColumns)

        // return returnColumns;

        // const columns = [
        // // {
        // //     name: "action",
        // //     header: "",
        // //     sortable: false,
        // //     showColumnMenuTool: false,
        // //     defaultWidth: 80,
        // //     render: (props) => {
        // //         // console.log(props)
        // //       return (
        // //         <DataGridRowActionMenu
        // //             data={props?.data}
        // //             mainMenus={[
        // //                 {
        // //                     displayText: "VIEW",
        // //                     onClick: (data) => {
        // //                         // console.log('dataSource222', gridRef.current.getSelectedId())
        // //                         // gridRef.current.deselectAll()
        // //                         console.log('row clicked', data)
        // //                     }
        // //                 }
        // //             ]}
        // //         />
        // //       )
        // //     }
        // // },
        // // { name: 'account_code', header: 'Account Code', defaultFlex: 1, sortable: true, showColumnMenuTool: false },
        // { name: 'doc_number', header: 'Doc No.', defaultFlex: 1, showColumnMenuTool: false, render: ({ value, cellProps }) => <Link to={`/admin/documents/salesOrder/update/${cellProps.data.id}`}>{value}</Link>},
        // { name: 'doc_date', header: 'Doc Date', defaultFlex: 1, showColumnMenuTool: false },
        // { name: 'profile_name', header: 'Profile', defaultFlex: 1, showColumnMenuTool: false },
        // { name: 'billing_profile_name', header: 'Billing', defaultFlex: 1, showColumnMenuTool: false },
        // { name: 'delivery_profile_name', header: 'Delivery', defaultFlex: 1, showColumnMenuTool: false },
        // { name: 'ax_createdatetime', header: 'Created At', defaultFlex: 1, showColumnMenuTool: false },
        // // { 
        // //     name: 'ax_createdatetime', 
        // //     header: 'Created At', 
        // //     defaultFlex: 1, 
        // //     filterEditor: DateFilter, 
        // //     showColumnMenuTool: false,
        // //     // filterEditorProps: (props, { index }) => {
        // //     //   // for range and notinrange operators, the index is 1 for the after field
        // //     //   return {
        // //     //     dateFormat: 'YYYY-MM-DD',
        // //     //     cancelButton: false,
        // //     //     highlightWeekends: false,
        // //     //     placeholder: index == 1 ? 'Created date is before...': 'Created date is after...'
        // //     //   }
        // //     // }, 
        // //     // render: ({ value, cellProps }) => {
        // //     //   return moment(value).format('YYYY-MM-DD')
        // //     // }
        // //     },
        // ];
    }

    const getRenderColumnTextDisplay = (display) => {
        return (
            <Typography
                sx={{
                    fontSize: 14
                }}
            >
                {display}
            </Typography>
        )
    }

    const getRenderColumnLink = (url, display/* , allowDuplicate = false */) => {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }}
            >
                <Link to={`${url}`}>
                    {display}
                </Link>
                {/* {
                    allowDuplicate &&
                    <Tooltip title={`Duplicate`}>
                        <IconButton
                            size="small"
                        >
                            
                            <CommonIcons name={icons.duplicate} /> 
                        </IconButton>
                    </Tooltip>
                } */}
            </Box>
        )
    }

    const getRenderColumnDateDisplay = (value) => moment(value).format('YYYY-MM-DD')
    const getRenderColumnDateTimeDisplay = (value) => moment(value).format('YYYY-MM-DD, h:mm:ss a')

    const getRenderColumnBooleanDisplay = (val, displayOptions, colorOptions, valToSkip = '') => {

        if (val === "1") {
            val = true
        } else if (val === "0") {
            val = false;
        }

        val = Boolean(val);

        let display
        let color

        if (val === true) {
            display = displayOptions[0]
            color = colorOptions[0]
        } else {
            display = displayOptions[1]
            color = colorOptions[1]
        }

        if (display === valToSkip) return <></>

        return (
            <Chip
                //   icon={<StoreIcon />}
                label={`${display}`}
                color={`${color}`}
                size="small"
                sx={{
                    ml: 1,
                    // textTransform: 'uppercase'
                }}
            />
        )
    }

    return {
        defineColumns,
        hideDefaultColumns,
        defineRowMenuRender,
        columns,
        filterValues,
        // filterTypes,
        getRenderColumnTextDisplay,
        getRenderColumnLink,
        getRenderColumnDateDisplay,
        getRenderColumnDateTimeDisplay,
        getRenderColumnBooleanDisplay
    }
}